import { ArrowRight, Feather } from "lucide-react";
import { Reveal } from "./Reveal";
import { CountdownTimer } from "./CountdownTimer";
import { CHECKOUT_URL, PRICE_ORIGINAL, PRICE_DISCOUNTED } from "@/lib/constants";

export const FinalCta = () => (
  <section data-testid="final-cta-section" className="relative py-24 md:py-32 overflow-hidden">
    <div className="absolute inset-0 pointer-events-none">
      <div className="absolute bottom-[-40%] left-1/2 -translate-x-1/2 w-[1000px] h-[600px] bg-[#d4af37]/[0.08] blur-[140px] rounded-full" />
    </div>
    <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#d4af37]">A decisão é sua — e ela depende só de você</p>
        <h2 className="mt-5 font-serif text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#f4f1ea] leading-tight">
          Comece hoje a construir<br />
          <span className="text-gold-gradient italic">a sua mente inabalável.</span>
        </h2>
        <p className="mt-6 text-base sm:text-lg text-zinc-400 leading-relaxed max-w-xl mx-auto">
          O preço promocional de lançamento pode sair do ar a qualquer momento.
          Garanta agora e comece a ler nos próximos 2 minutos.
        </p>
      </Reveal>
      <Reveal delay={0.1} className="mt-9 flex justify-center">
        <CountdownTimer variant="full" />
      </Reveal>
      <Reveal delay={0.15}>
        <div className="mt-9 flex items-baseline justify-center gap-4">
          <span className="text-zinc-500 line-through text-xl">{PRICE_ORIGINAL}</span>
          <span className="font-serif text-5xl sm:text-6xl font-bold text-gold-gradient">{PRICE_DISCOUNTED}</span>
        </div>
        <a
          data-testid="final-buy-button"
          href={CHECKOUT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="group mt-8 inline-flex items-center gap-3 bg-gold-gradient text-[#08080a] font-extrabold text-base sm:text-lg px-12 py-5 rounded-full gold-glow transition-transform duration-300 hover:scale-[1.05]"
        >
          Garantir meu exemplar agora
          <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" />
        </a>
        <p className="mt-5 text-xs text-zinc-600">Compra segura · Download imediato · Garantia de 7 dias</p>
      </Reveal>
    </div>

    <footer data-testid="footer" className="relative mt-24 border-t border-[#d4af37]/10 pt-10 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <span className="flex items-center gap-2.5">
          <Feather className="w-4 h-4 text-[#d4af37]" strokeWidth={1.5} />
          <span className="font-serif text-lg tracking-[0.28em] text-[#f4f1ea]">ESTÓICO</span>
        </span>
        <p className="text-xs text-zinc-600 text-center">
          © {new Date().getFullYear()} LF Silva · Todos os direitos reservados · Este site não substitui acompanhamento psicológico profissional.
        </p>
      </div>
    </footer>
  </section>
);
